import { useProgressiveOnboarding } from 'providers/ProgressiveOnboarding/ProgressiveOnboardingProvider';

import {
  PROGRESSIVE_ONBOARDING_PS_APP_RELEASE,
  PROGRESSIVE_ONBOARDING_SHOPPER,
} from 'components/admin/utils/feature-flags';
import { Stack } from 'components/layout';
import { ProgressTracker } from 'components/ProgressiveOnboarding/ProgressTracker';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import {
  PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY,
  PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY,
  SHOPPER_FEATURE_KEY,
} from 'providers/ProgressiveOnboarding/constants/constants';
import { Guide } from 'providers/ProgressiveOnboarding/types';
import { useEffect, useState } from 'react';

export const ProgressiveOnboardingContainer = () => {
  const { availableGuides, isLoading, error } = useProgressiveOnboarding();
  const [filteredGuides, setFilteredGuides] = useState<Guide[]>([]);
  const { hasLabsFlag } = usePSLabs();

  const hasShopperFlag = hasLabsFlag(PROGRESSIVE_ONBOARDING_SHOPPER);
  const hasPSAppReleaseFlag = hasLabsFlag(
    PROGRESSIVE_ONBOARDING_PS_APP_RELEASE,
  );

  useEffect(() => {
    const filteredGuides = availableGuides.filter((guide) => {
      // Filter out SHOPPER_FEATURE_KEY if user doesn't have PROGRESSIVE_ONBOARDING_SHOPPER flag
      if (guide.key === SHOPPER_FEATURE_KEY && !hasShopperFlag) {
        return false;
      }

      // Filter out PS_APP guides if user doesn't have PROGRESSIVE_ONBOARDING_PS_APP_RELEASE flag
      if (
        (guide.key === PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY ||
          guide.key === PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY) &&
        !hasPSAppReleaseFlag
      ) {
        return false;
      }

      return true;
    });
    setFilteredGuides(filteredGuides);
  }, [hasShopperFlag, hasPSAppReleaseFlag, availableGuides]);

  if (isLoading || error) {
    return null;
  }

  return (
    <Stack gap="var(--spacing-1)" alignSelf="stretch">
      {filteredGuides.map((guide) => (
        <ProgressTracker guide={guide} key={guide.key} />
      ))}
    </Stack>
  );
};
